import { base_colorSurface } from 'ext-ui/style/colors'
import { css } from 'styled-components'

export const container = css`
  height: 100%;
  display: flex;
  flex-direction: column;
  background: ${base_colorSurface};
`
